<template>
  <v-card>
    <v-card-title class="d-flex justify-center">
      <span class="font-weight-bold">Tagihan Pasien</span>
      <v-btn absolute right text icon @click="closeButton">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <div style="max-height: 88vh; overflow-y: auto;" class="scrollbar mx-1">
      <div class="mt-5">
        <div>
          <div class="mx-4" style="display: flex; gap: 20px;">
            <div class="text-left">
              <span class="text-blue font-weight-medium text-subtitle-1"
                >Data Pasien</span
              >
              <div
                class="box-data__grey py-5 px-5"
                style="display:flex; gap: 10px; width: fit-content; border-radius: 10px;"
              >
                <div class="card-label" style="width: 150px;">
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey">No. RM</span>
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ billingData.rm_number }}</span
                    >
                  </div>
                  <div class="flex-label border-right" style="height: 100%;">
                    <span class="text-body-2 text-light-grey">No Kartu</span>
                    <span class="font-weight-medium text-body-2 text-dark-grey"
                      >-</span
                    >
                  </div>
                </div>
                <div class="card-label">
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey">Nama Pasien</span>
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ `${billingData.name} (${patientBill.gender})` }}</span
                    >
                  </div>
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey"
                      >Tanggal Lahir</span
                    >
                    <span class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ patientBill.dobFormatted }} ({{
                        patientBill.ageFormatted
                      }})</span
                    >
                  </div>
                </div>
                <div class="card-label">
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey">Unit</span>
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ `${billingData.unit}` }}</span
                    >
                  </div>
                  <div class="flex-label border-right" style="height: 100%;">
                    <span class="text-body-2 text-light-grey"
                      >No Pendaftaran</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ patientBill.registNumber }}</span
                    >
                  </div>
                </div>
                <div class="card-label">
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey"
                      >Tanggal Masuk</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ `${patientBill.enterDate} WIB` }}</span
                    >
                  </div>
                  <div class="flex-label border-right" style="height: 100%;">
                    <span class="text-body-2 text-light-grey"
                      >Tanggal Keluar</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ `${patientBill.leaveDate} WIB` }}</span
                    >
                  </div>
                </div>
                <div class="card-label">
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey"
                      >Status Kelas</span
                    >
                    <span class="font-weight-medium text-body-2 text-dark-grey"
                      >-</span
                    >
                  </div>
                  <div class="flex-label " style="height: 100%;">
                    <span class="text-body-2 text-light-grey"
                      >Tipe Penjamin</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ billingData.assurance.toUpperCase() }}</span
                    >
                  </div>
                </div>
                <div class="card-label">
                  <div class="flex-label">
                    <span class="text-body-2 text-light-grey">DPJP</span>
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ patientBill.doctor }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="text-left" style="flex-grow: 1;">
              <span class="text-blue font-weight-medium text-subtitle-1"
                >Ringkasan Tagihan</span
              >
              <div
                class="box-data__grey py-5 px-5 mt-2"
                style="display:flex; gap: 10px; border-radius: 10px;"
              >
                <div class="card-label" style="width: 100%;">
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey"
                      >Tagihan Klinik</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ currency(patientBill.sub_total || 0) }}</span
                    >
                  </div>
                  <div class="flex-label border-right">
                    <span class="text-body-2 text-light-grey"
                      >Data Kebajikan</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ currency(patientBill.kebajikan || 0) }}</span
                    >
                  </div>
                </div>
                <div class="card-label" style="width: 100%;">
                  <div class="flex-label ">
                    <span class="text-body-2 text-light-grey"
                      >Hal Kelas/Limit</span
                    >
                    <span
                      class="font-weight-medium text-body-2 text-dark-grey"
                      >{{ currency(patientBill.insurance || 0) }}</span
                    >
                  </div>
                  <div class="flex-label">
                    <span class="text-body-2 text-light-grey"
                      >Tagihan Pasien</span
                    >
                    <span class="font-weight-medium text-body-2 text-blue">{{
                      currency(patientBill.remaining_bill || 0)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
          class="mx-5 my-5"
        >
          <div
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <span class="text-blue font-weight-medium text-subtitle-1"
              >Tagihan
            </span>
            <div class="d-flex text-left flex-column">
              <div class="d-flex flex-row align-center">
                <div v-if="patientBill.isPaid" class="box-green ml-3 py-1 px-2">
                  <v-icon class="mr-2" small color="#268843">mdi-check</v-icon>
                  <span class="text-body-2">Lunas</span>
                </div>
              </div>
            </div>
          </div>

          <div
            style="display: flex; justify-content: space-between; align-items: center; gap: 20px;"
          >
            <div style="width: 300px;">
              <v-text-field
                class="input"
                background-color="grey lighten-3"
                placeholder="Cari"
                solo
                dense
                hide-details
                flat
                prepend-inner-icon="mdi-magnify"
                single-line
                v-model="search"
              ></v-text-field>
            </div>

            <v-icon @click="printInvoice()">mdi-printer</v-icon>
            <v-menu
              v-if="patientBill.assurance === 'ASURANSI'"
              left
              :offset-x="true"
              :close-on-content-click="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <v-list style="padding: 0px; min-width: 10.5rem;">
                <v-list-item @click="onClick(1)" class="dropdown">
                  <v-list-item-title>
                    <span class="dropdown-item">
                      Input Limit Asuransi
                    </span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
        <div class="mx-5" v-if="isLoading">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </div>
      </div>
      <div>
        <div
          v-if="patientBill.isOverpayment"
          class="overpayment-info px-3 py-2 mt-3"
        >
          <v-icon small color="primary" class="mr-2">mdi-information</v-icon>
          <span for=""
            >Pasien memiliki sisa kembalian sebanyak
            {{ currency(patientBill.overpayment) }}
          </span>
        </div>
        <div class="mt-4 mx-5">
          <div
            v-for="(v, index) in itemBilling"
            :key="`table-${index}`"
            class="mb-3"
          >
            <h4 class="text-start table-header-text">{{ v.unit }}</h4>
            <v-form ref="formItemDisc">
              <v-data-table
                :headers="
                  v.unit !== 'Tagihan Tambahan'
                    ? headersBilling
                    : [
                        ...headersBilling.slice(0, 3), // Elements before the specified 2
                        { text: 'Unit', value: 'unit_name', width: '10%' }, // The new element
                        ...headersBilling.slice(3), // Elements from the specified 2 onward
                      ]
                "
                :items="v.billing"
                :search="search"
                :loading="isLoading"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.no`]="{ item }">
                  <tr>
                    <td>{{ v.billing.indexOf(item) + 1 }}</td>
                  </tr>
                </template>
                <template v-slot:[`item.quantity`]="{ item }">
                  <div v-if="item.isIntervention" style="width: 60px;">
                    <v-currency-field
                      v-model="item.quantity"
                      dense
                      single-line
                      :disabled="patientBill.isPaid"
                      :rules="[v => v > 0 || 'Belum diisi']"
                      @input="
                        onInputQty($event, index, v.billing.indexOf(item))
                      "
                    />
                  </div>
                  <div v-else>{{ item.quantity }}</div>
                </template>
                <template v-slot:[`item.price`]="{ item }">
                  <div>{{ currency(parseInt(item.price || 0)) }}</div>
                </template>
                <template v-slot:[`item.subTotal`]="{ item }">
                  <tr>
                    <td>{{ currency(item.subTotal || 0) }}</td>
                  </tr>
                </template>
                <template v-slot:[`item.discount`]="{ item }">
                  <td class="text-right d-flex items-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="
                            switchDiscountType(index, v.billing.indexOf(item))
                          "
                          class="mr-2"
                          text
                          small
                          fab
                          depressed
                          v-bind="attrs"
                          v-on="on"
                          :disabled="patientBill.isPaid"
                        >
                          <v-icon color="#757575">mdi-swap-vertical</v-icon>
                        </v-btn>
                      </template>
                      <span>Ubah mode diskon</span>
                    </v-tooltip>

                    <v-currency-field
                      v-show="item.discountType === 'nominal'"
                      class="input-end"
                      v-model="item.discountNominal"
                      placeholder="0,00"
                      prefix="Rp"
                      dense
                      single-line
                      :disabled="patientBill.isPaid"
                      @focus="shouldCalc = true"
                      :rules="[
                        v =>
                          formatToNumber(v) <= item.subTotal ||
                          'Nilai melebihi total tagihan',
                      ]"
                      @input="
                        onInputDiscount($event, index, v.billing.indexOf(item))
                      "
                      :decimal-length="2"
                      auto-decimal-mode
                    />
                    <v-currency-field
                      v-show="item.discountType === 'percent'"
                      class="input-end"
                      v-model="item.discountPercent"
                      placeholder="0"
                      suffix="%"
                      dense
                      single-line
                      :disabled="patientBill.isPaid"
                      @focus="shouldCalc = true"
                      @input="
                        onInputDiscount($event, index, v.billing.indexOf(item))
                      "
                      :decimal-length="2"
                      auto-decimal-mode
                      :rules="[
                        v => formatToNumber(v) < 101 || 'Diskon melebihi 100%',
                      ]"
                    />
                  </td>
                </template>
                <template v-slot:[`item.total`]="{ item }">
                  {{ currency(item.total || 0) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    v-show="!patientBill.isPaid"
                    small
                    class="mr-2"
                    @click="
                      $refs[`jumlah${item.id}`].isActive = true;
                      $refs[`diskon${item.id}`].isActive = true;
                    "
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    small
                    v-show="!patientBill.isPaid"
                    @click="deleteItem(item)"
                    color="red"
                  >
                    mdi-close-box
                  </v-icon>
                </template>
                <template v-slot:[`body.append`]>
                  <tr class="total-row">
                    <td class="text-right font-weight-bold" :colspan="9">
                      Total
                    </td>
                    <td :colspan="2" class="text-left font-weight-bold">
                      {{
                        currency(
                          v.billing.reduce((a, b) => a + b.total, 0) || 0,
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-form>
          </div>
        </div>
        <div class="mx-5 mt-7">
          <v-form ref="addOnDisc" v-if="!isLoading">
            <div style="display: flex; justify-content: space-between; ">
              <div class="text-left" style="width: 330px;">
                <label class="text-body-2 text-light-grey">Alasan Diskon</label>
                <v-textarea
                  v-model="discountReason"
                  placeholder="Masukkan disini"
                  @change="
                    findAndPushItem({ id: 'discount_all' }, 'discount_all')
                  "
                  outlined
                  :disabled="patientBill.isPaid"
                >
                </v-textarea>
              </div>
              <div
                style="width: 380px; display: flex; flex-direction: column; row-gap: 10px;"
              >
                <div style="display: flex; justify-content: space-between;">
                  <label>Total</label>
                  <label>{{ currency(totalPrice) }}</label>
                </div>
                <div
                  style="display: flex; justify-content: space-between; align-items: center;"
                >
                  <label>Diskon Tambahan</label>
                  <div
                    style="display: flex; justify-content: space-between; gap: 5px; "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="
                            extraDiscountType =
                              extraDiscountType === 'percent'
                                ? 'nominal'
                                : 'percent';
                            shouldCalc = false;
                            findAndPushItem(
                              { id: 'discount_all' },
                              'discount_all',
                            );
                          "
                          class="mr-2"
                          text
                          small
                          fab
                          depressed
                          v-on="on"
                          v-bind="attrs"
                          :disabled="patientBill.isPaid"
                        >
                          <v-icon color="#757575">mdi-swap-vertical</v-icon>
                        </v-btn>
                      </template>
                      <span>Ubah mode diskon</span>
                    </v-tooltip>

                    <div style="width: 150px;">
                      <v-currency-field
                        v-if="extraDiscountType === 'nominal'"
                        class="input-end"
                        v-model="discNominal"
                        placeholder="0,00"
                        prefix="Rp"
                        dense
                        single-line
                        @focus="shouldCalc = true"
                        @input="onInputXtraDiscount($event)"
                        :decimal-length="2"
                        hide-details="auto"
                        :disabled="patientBill.isPaid"
                        :rules="[
                          v =>
                            formatToNumber(v) <= totalPrice ||
                            'Nilai melebihi total tagihan',
                        ]"
                        auto-decimal-mode
                      />
                      <v-currency-field
                        v-if="extraDiscountType === 'percent'"
                        class="input-end"
                        v-model="discPercent"
                        placeholder="0"
                        suffix="%"
                        dense
                        single-line
                        @focus="shouldCalc = true"
                        @input="onInputXtraDiscount($event)"
                        :decimal-length="2"
                        hide-details="auto"
                        :disabled="patientBill.isPaid"
                        :rules="[
                          v =>
                            formatToNumber(v) < 101 || 'Diskon melebihi 100%',
                        ]"
                        auto-decimal-mode
                      />
                    </div>
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <label>Harga Total</label>
                  <label>{{ currency(totalAllDiscountPrice) }}</label>
                </div>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>

    <v-card-actions color="white" class="py-3">
      <div
        style="display: flex; justify-content: space-between; align-items: center; width: 100%;"
      >
        <!-- <v-btn
        depressed
        color="primary"
        outlined
        width="100"
        class="ml-2"
        @click="printInvoice"
      >
        <v-icon class="mr-1">mdi-printer</v-icon>
        Print
      </v-btn> -->

        <div
          style="height: 36px"
          class="price-box mx-2 d-flex align-center px-4"
        >
          <v-row no-gutters>
            <span class="text-subtitle-2">Total Tagihan Pasien</span>
            <span class="price-text ml-6">
              {{ currency(patientBill.total_bill || 0) }}</span
            >
          </v-row>
        </div>
        <!-- <v-btn
        depressed
        outlined
        color="primary"
        @click="onClick(1)"
        class="mx-2"
        v-if="
          !patientBill.assurance === 'UMUM' ||
            !patientBill.assurance === 'BPJS' ||
            !patientBill.isPaid === true
        "
      >
        Input Limit Asuransi
      </v-btn> -->
        <div v-if="!isLoading">
          <v-btn
            v-show="patientBill.isPaid"
            class="mx-2 text-none"
            @click="cancelPaid()"
            elevation="0"
            :style="{ backgroundColor: 'transparent', color: '#C62828' }"
            v-if="patientBill.cancelable"
          >
            <v-icon color="#C62828" small>mdi-close</v-icon>
            Batalkan Pelunasan</v-btn
          >
          <v-btn
            depressed
            color="primary"
            class="mx-2 text-none"
            v-if="!patientBill.isPaid && this.hasItemChanges"
            @click="updateItem"
            outlined
            :disabled="isInvalidDiscount || isAddonDiscInvalid"
          >
            Simpan Perubahan
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="mx-2 text-none"
            width="90"
            v-if="!patientBill.isPaid"
            @click="onClick(2)"
            :disabled="isInvalidDiscount || isAddonDiscInvalid"
          >
            {{ billingData.isWadiah ? 'Topup' : 'Bayar' }}
          </v-btn>
        </div>
      </div>
    </v-card-actions>
    <v-dialog v-model="dialog" :max-width="selectedItem === 2 ? 200 : 1280">
      <InputHakKelas
        v-if="selectedItem === 1 && dialog"
        :data="patientBill"
        @close-form="closeForm(0)"
      />
      <v-card v-if="selectedItem === 2 && dialog" height="200">
        <div class="pa-3">
          <h3>Pilih Cara Bayar</h3>
        </div>
        <div class="pa-3">
          <v-btn
            @click="
              selectedButton = 'debit';
              debitModal = true;
              dialog = false;
            "
            class="button-payment text-none"
            :class="{ active: selectedButton === 'debit' }"
            >Debit</v-btn
          >
        </div>
        <div class="pa-3">
          <v-btn
            @click="
              selectedButton = 'tunai';
              debitModal = true;
              dialog = false;
            "
            class="button-payment text-none"
            :class="{ active: selectedButton === 'tunai' }"
            >Tunai</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="debitModal" width="450">
      <PaymentInput
        v-if="debitModal"
        :data="patientBill"
        :selectedButton="selectedButton"
        @close-form="closeForm(1)"
        @refreshed="getData()"
      ></PaymentInput>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from 'moment-timezone';
import InputHakKelas from './InputHakKelas';
import PaymentInput from './PaymentInput';
import formatMixin from '@/mixin/formatMixin';
import 'jspdf-autotable';
import Constant from '@/const';
import Swal from 'sweetalert2';
import printMixin from '@/mixin/printMixin';
import printInvoices from '@/mixin/printInvoices';
import alertMixin from '@/mixin/alertMixin';

const axios = require('axios');
const _ = require('lodash');

export default {
  name: 'DialogBilling',
  mixins: [printMixin, printInvoices, alertMixin, formatMixin],
  components: {
    InputHakKelas,
    PaymentInput,
  },
  props: {
    billingData: Object,
  },
  data() {
    return {
      clientData: this.$store.getters.userLoggedIn.clinic,
      headersBilling: [
        {
          text: 'No',
          sortable: false,
          value: 'no',
          width: '3%',
        },
        {
          text: 'Tanggal',
          align: 'start',
          sortable: false,
          value: 'created_at',
          width: '5%',
        },
        {
          text: 'Item Pelayanan',
          value: 'name',
          width: '20%',
        },
        { text: 'Operator', value: 'created_by' },
        { text: 'Jumlah', value: 'quantity' },
        { text: 'Satuan', value: 'unit' },
        { text: 'Harga', value: 'price' },
        { text: 'Sub Total', value: 'subTotal' },
        { text: 'Diskon', value: 'discount', width: '13%', align: 'end' },
        { text: 'Total', value: 'total', align: 'end', width: '10%' },
        // { text: 'Actions', value: 'actions', sortable: false },
      ],
      rules: {
        discountNominal: v =>
          this.formatToNumber(v) < this.totalBill ||
          'Nilai melebihi total tagihan',

        discountPercent: v =>
          this.formatToNumber(v) < 101 || 'Nilai melebihi 100%',
      },
      itemBillingOrigin: [],
      itemBilling: [],
      isChangesValid: true,
      extraDiscountType: 'nominal',
      discNominal: 0,
      discPercent: 0,
      shouldCalc: true,
      dialog: false,
      selectedItem: 0,
      search: '',
      selectedButton: 'debit',
      debitModal: false,
      patientBill: [],
      isLoading: false,
      disabled: false,
      updatePayload: [],
      discountReason: '',
    };
  },
  computed: {
    letterData() {
      return Constant.client.find(
        item =>
          item.name.toLowerCase() ===
          this.$store.getters.userLoggedIn.clinic.name.toLowerCase(),
      );
    },
    totalAllDiscountPrice() {
      const totalPrice = this.itemBilling.reduce(
        (next, prev) => next + prev.billing.reduce((a, b) => a + b.total, 0),
        0,
      );
      if (this.extraDiscountType === 'percent') {
        return totalPrice - (totalPrice * this.discPercent) / 100;
      } else {
        return (totalPrice || 0) - this.discNominal;
      }
    },
    totalPrice() {
      return this.itemBilling.reduce(
        (next, prev) => next + prev.billing.reduce((a, b) => a + b.total, 0),
        0,
      );
    },
    hasItemChanges() {
      const itemBillingChanges = JSON.stringify({
        billing: this.itemBilling,
        extra: {
          discountReason: this.discountReason,
          extraDiscountType: this.extraDiscountType,
          discPercent: this.discPercent,
          discNominal: this.discNominal,
        },
      });
      return itemBillingChanges !== this.itemBillingOrigin;
    },
    isInvalidDiscount() {
      return this.itemBilling.some(item =>
        item.billing.some(bill =>
          bill.discountType === 'percent'
            ? bill.discountPercent > 100
            : bill.discountNominal > bill.subTotal || bill.quantity <= 0,
        ),
      );
    },
    isAddonDiscInvalid() {
      return this.extraDiscountType === 'percent'
        ? this.discPercent > 100
        : this.discNominal > this.totalPrice;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
    });
  },
  methods: {
    switchDiscountType(index, itemIndex) {
      this.shouldCalc = false;
      const bill = this.itemBilling[index].billing[itemIndex];
      bill.discountType =
        bill.discountType === 'nominal' ? 'percent' : 'nominal';
      this.findAndPushItem(bill, 'discount_item');
      this.$refs.formItemDisc.resetValidation();
    },
    deleteItem(item) {
      const payload = {
        staff: this.$store.getters.userLoggedIn.id,
      };
      Swal.fire({
        html: `Anda akan menghapus<br/> <strong>${item.name}?<strong/>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
      }).then(result => {
        if (result.value) {
          axios
            .put(
              Constant.apiUrl.concat(
                `/billing/delete/${this.billingData.id}/${item.id}/${item.type}`,
              ),
              payload,
            )
            .then(response => {
              if (response) {
                Swal.fire(
                  `${item.name} berhasil dihapus dari tagihan`,
                  '',
                  'success',
                );
                this.getData();
              }
            })
            .catch(error => {
              if (error) {
                Swal.fire(
                  `${item.name} gagal dihapus dari tagihan`,
                  '',
                  'error',
                );
              }
            });
        }
      });
    },

    async updateItem() {
      this.isLoading = true;
      axios
        .put(
          Constant.apiUrl.concat(
            `/billing/quantity-discount/${this.billingData.id}`,
          ),
          { updates: this.updatePayload },
        )
        .then(response => {
          if (response) {
            this.getData();
            this.isLoading = false;
            this.updatePayload = [];
          }
        })
        .catch(error => {
          if (error) {
            this.isLoading = false;
          }
        });
    },
    closeButton() {
      if (this.hasItemChanges) {
        Swal.fire({
          title: `<div style="font-family: Roboto, Serif; color: #404040; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Perubahan belum disimpan</p></div>`,
          iconHtml: `
                      <span
                        class="mdi mdi-alert-circle-outline"
                        style="
                          color: #F9A825;
                          border: 4px solid #fdeec8;
                          border-radius: 999px;
                          padding: 1.5rem;
                          display: inline-flex;
                          align-items: center;
                          justify-content: center;
                          width: 2rem;
                          height: 2rem;
                        ">
                      </span>`,
          html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>Data yang Anda masukkan akan hilang. Kembali dan simpan perubahan terlebih dahulu</p></div>`,
          showCancelButton: true,
          customClass: {
            confirmButton: 'button-confirm',
            cancelButton: 'button-cancel',
          },
          confirmButtonText: 'Kembali',
          cancelButtonText: 'Keluar',
          reverseButtons: true,
        }).then(async response => {
          if (!response.isConfirmed) {
            this.$emit('close-form');
          }
        });
      } else {
        this.$emit('close-form');
      }
    },
    closeForm(index) {
      switch (index) {
        case 0:
          this.getData();
          this.dialog = false;
          break;
        case 1:
          this.getData();
          this.debitModal = false;
          break;
        default:
          this.dialog = false;
          break;
      }
    },
    getData() {
      this.isLoading = true;
      axios
        .get(Constant.apiUrl.concat(`/billing/${this.billingData.id}`))
        .then(response => {
          const { data } = response.data;
          this.lengthPage = Math.ceil(data.length / 5);
          const addressData = [data.id_emr.social.address.text];

          if (data.id_emr.social.address.sub_district) {
            addressData.push(data.id_emr.social.address.sub_district);
          }
          if (data.id_emr.social.address.district) {
            addressData.push(data.id_emr.social.address.district);
          }
          if (data.id_emr.social.address.city) {
            addressData.push(data.id_emr.social.address.city);
          }
          if (data.id_emr.social.address.province) {
            addressData.push(data.id_emr.social.address.province);
          }

          this.patientBill = {
            id: data._id,
            isCash: data.isCash,
            cancelable: data.cancelable,
            name: data.id_emr.social.name,
            registNumber: data.id_registration.registration_number,
            rm_number: data.id_emr.medical_record_number,
            assurance: data.id_registration.assurance.type.toUpperCase(),
            unit: _.get(data, 'id_registration.id_unit.name', '-'),
            status: data.id_registration ? 'Pasien Terdaftar' : '',
            isPaid: data.isPaid,
            gender: data.id_emr.social.gender ? 'Laki-laki' : 'Perempuan',
            age: data.id_emr.social.age,
            date: moment(data.id_registration.timestamps.created_at)
              .locale('id')
              .format('l'),
            time: moment(data.id_registration.timestamps.created_at)
              .locale('id')
              .format('HH:mm'),
            isWadiah: this.billingData.isWadiah,
            detail: data.detail,
            sub_total: data.sub_total,
            total_paid: data.total_paid,
            total_bill: data.total_bill,
            insurance:
              data.insurance_limit.length === 0
                ? 0
                : data.insurance_limit[0].amount,
            kebajikan: data.benevolence_fund,
            enterDate: moment(data.id_registration.timestamps.created_at)
              .locale('id')
              .format('dddd, DD/MM/yyyy HH:mm'),
            leaveDate: data?.finished_at
              ? moment(data.finished_at)
                  .locale('id')
                  .format('dddd, DD MMMM YYYY HH:mm')
              : '-',
            doctor: data.staff_name,
            dob: moment(data.id_emr.social.birth.date)
              .locale('id')
              .format('ll'),
            dobFormatted: moment(data.id_emr.social.birth.date).format(
              'DD-MM-YYYY',
            ),
            ageFormatted: this.ageDuration(
              moment(data.id_emr.social.birth.date),
            ),
            remaining_bill: data.remaining_bill,
            total_wadiah: data.total_wadiah,
            isBpjs: data.isBpjs,
            isInsurance: data.isInsurance,
            isOverpayment: data.isOverpayment,
            overpayment: data.overpayment,
            wadiah: data.wadiah,
            payment: data.payment,
            return_detail: data.return_detail,
            id_registration: data.id_registration._id,
            id_emr: data.id_registration.id_emr,
            total_return: data.total_return,
            hak_kelas: data.hak_kelas,
            insurance_limit: data.insurance_limit,
            address: addressData.join(', '),
            rawEnterDate: data.id_registration.timestamps.created_at,
            rawLeaveDate: data?.finished_at,
            repayment: data?.payment[0]?.timestamps?.created_at,
            discountNominal: data?.discount_nominal,
          };
          this.discountReason = data?.discount_reason;
          this.extraDiscountType = data?.discount_type;
          this.discNominal = data?.discount_nominal;
          this.discPercent = data?.discount_percent;

          this.itemBilling = data.detail.map(bill => {
            return {
              unit: bill.unit,
              billing: bill.item.map(i => {
                const data = {
                  id: i.id,
                  unit_name: i.unit_name,
                  created_at: moment(i.created_at, 'DD/MM/YYYY')
                    .locale('id')
                    .format('L'),
                  name: i.name,
                  discountType:
                    i.discount_type === null ? 'nominal' : i.discount_type,
                  discountNominal: i.discount_nominal || 0,
                  discountPercent: i.discount_percent || 0,
                  category: i.category,
                  subcategory: i.subcategory,
                  created_by: i.created_by,
                  quantity: i.quantity,
                  unit: i.package_unit || '-',
                  price: i.price,
                  id_intervention: i.id_intervention,
                  subTotal: i.subTotal,
                  isIntervention: i.isIntervention,
                  isConsumable: i.isConsumable,
                  isRecipe: i.isRecipe,
                  id_service: i.id_service,
                  id_drugs: i.id_drugs,
                  id_goods: i.id_goods,
                  id_consumable: i.id_consumable,
                  id_recipe: i.id_recipe,
                  type: i.type,
                  total: !i.total ? this.calcTotalPerItems(i) : i.total,
                };
                return data;
              }),
            };
          });
          this.itemBillingOrigin = JSON.stringify({
            billing: this.itemBilling,
            extra: {
              discountReason: this.discountReason,
              extraDiscountType: this.extraDiscountType,
              discPercent: this.discPercent,
              discNominal: this.discNominal,
            },
          });
          this.isLoading = false;
        });
    },
    calcTotalPerItems(item) {
      const discount =
        item.discount_type === 'percent'
          ? item.discount_percent
          : item.discount_nominal;

      if (item.discount_type === 'percent') {
        return item.subTotal - item.subTotal * (discount / 100);
      } else {
        return item.subTotal - discount;
      }
    },
    onClick(index) {
      switch (index) {
        case 1:
          this.selectedItem = index;
          this.dialog = true;
          break;
        case 2:
          if (this.hasItemChanges) {
            this.updateItem().then(() => {
              this.selectedItem = index;
              this.dialog = true;
            });
          } else {
            this.selectedItem = index;
            this.dialog = true;
          }

          break;
        default:
          this.dialog = true;
          break;
      }
    },
    cancelPaid() {
      const payload = {
        cancel_by: this.$store.getters.userLoggedIn.id,
      };

      Swal.fire({
        html:
          '<strong>Anda akan melanjutkan<br/> pembatalan pelunasan tagihan<strong/>',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
      }).then(result => {
        if (result.value) {
          axios
            .put(
              Constant.apiUrl.concat(
                `/billing/rollback/${this.patientBill.id_registration}`,
              ),
              payload,
            )
            .then(response => {
              if (response.status === 200) {
                Swal.fire('Berhasil', `${response.data.pesan}`, 'success').then(
                  result => {
                    if (result.isConfirmed) {
                      this.$emit('close-form');
                    }
                  },
                );
              }
            })
            .catch(error => {
              this.showErrorAxios(error);
            });
        }
      });
    },
    printInvoice() {
      const doc = this.printBillingInvoice({
        billingData: this.billingData,
        patientBill: this.patientBill,
        billingItems: this.itemBilling,
      });
      // print action
      this.printDocument(doc, {
        docName: 'Kuitansi Pasien',
        rmNumber: this.billingData.rm_number,
      });
    },
    editItem(item) {
      if (item.isIntervention) {
        const payload = {
          timestamps: {
            created_by: this.$store.getters.userLoggedIn.id,
            created_at: moment(new Date()).format(),
          },
          sub_total: this.patientBill.sub_total,
          isBpjs: this.patientBill.isBpjs,
          isInsurance: this.patientBill.isInsurance,
          total_bill: this.patientBill.total_bill,
          remaining_bill: this.patientBill.remaining_bill,
          benevolence_fund: this.patientBill.kebajikan,
          wadiah: this.patientBill.wadiah,
          payment: this.patientBill.payment,
          total_paid: this.patientBill.total_paid,
          return_detail: this.patientBill.return_detail,
          total_return: this.patientBill.total_return,
          isPaid: this.patientBill.isPaid,
          id_registration: this.patientBill.id_registration,
          id_emr: this.patientBill.id_emr,
          hak_kelas: this.patientBill.hak_kelas,
          insurance_limit: this.patientBill.insurance_limit,
          detail: {
            intervention: [
              {
                id: item.id,
                timestamps: {
                  created_by: this.$store.getters.userLoggedIn.id,
                  created_at: moment(new Date()).format(),
                },
                id_service: item.id_service,
                operator: this.$store.getters.userLoggedIn.id,
                amount: item.quantity,
                package_unit: item.unit,
                price: item.price,
                discount: item.diskon,
              },
            ],
          },
        };
        axios
          .post(
            Constant.apiUrl.concat(`/billing/${this.patientBill.id}`),
            payload,
          )
          .then(() => this.getData());
      } else if (item.isRecipe) {
        const payload = {
          timestamps: {
            created_by: this.$store.getters.userLoggedIn.id,
            created_at: moment(new Date()).format(),
          },
          sub_total: this.patientBill.sub_total,
          isBpjs: this.patientBill.isBpjs,
          isInsurance: this.patientBill.isInsurance,
          total_bill: this.patientBill.total_bill,
          remaining_bill: this.patientBill.remaining_bill,
          benevolence_fund: this.patientBill.kebajikan,
          wadiah: this.patientBill.wadiah,
          payment: this.patientBill.payment,
          total_paid: this.patientBill.total_paid,
          return_detail: this.patientBill.return_detail,
          total_return: this.patientBill.total_return,
          isPaid: this.patientBill.isPaid,
          id_registration: this.patientBill.id_registration,
          id_emr: this.patientBill.id_emr,
          hak_kelas: this.patientBill.hak_kelas,
          insurance_limit: this.patientBill.insurance_limit,
          detail: {
            recipe: [
              {
                id: item.id,
                timestamps: {
                  created_by: this.$store.getters.userLoggedIn.id,
                  created_at: moment(new Date()).format(),
                },
                id_drugs: item.id_drugs,
                name_mix_recipe: item.name,
                operator: this.$store.getters.userLoggedIn.id,
                id_recipe: item.id_recipe,
                amount: item.quantity,
                package_unit: item.unit,
                price: item.price,
                discount: item.diskon,
              },
            ],
          },
        };
        axios
          .post(
            Constant.apiUrl.concat(`/billing/${this.patientBill.id}`),
            payload,
          )
          .then(() => this.getData());
      } else {
        const payload = {
          timestamps: {
            created_by: this.$store.getters.userLoggedIn.id,
            created_at: moment(new Date()).format(),
          },
          sub_total: this.patientBill.sub_total,
          isBpjs: this.patientBill.isBpjs,
          isInsurance: this.patientBill.isInsurance,
          total_bill: this.patientBill.total_bill,
          remaining_bill: this.patientBill.remaining_bill,
          benevolence_fund: this.patientBill.kebajikan,
          wadiah: this.patientBill.wadiah,
          payment: this.patientBill.payment,
          total_paid: this.patientBill.total_paid,
          return_detail: this.patientBill.return_detail,
          total_return: this.patientBill.total_return,
          isPaid: this.patientBill.isPaid,
          id_registration: this.patientBill.id_registration,
          id_emr: this.patientBill.id_emr,
          hak_kelas: this.patientBill.hak_kelas,
          insurance_limit: this.patientBill.insurance_limit,
          detail: {
            consumable: [
              {
                id: item.id,
                timestamps: {
                  created_by: this.$store.getters.userLoggedIn.id,
                  created_at: moment(new Date()).format(),
                },
                id_consumable: item.id_consumable,
                id_drugs: item.id_drugs,
                id_goods: item.id_goods,
                operator: this.$store.getters.userLoggedIn.id,
                id_recipe: item.id_recipe,
                amount: item.quantity,
                package_unit: item.unit,
                price: item.price,
                discount: item.diskon,
              },
            ],
          },
        };
        axios
          .post(
            Constant.apiUrl.concat(`/billing/${this.patientBill.id}`),
            payload,
          )
          .then(() => this.getData());
      }
    },

    onInputDiscount(event, index, itemIndex, override = false) {
      const item = this.itemBilling[index].billing[itemIndex];
      if (this.shouldCalc) {
        if (item.discountType === 'percent') {
          item.total =
            item.subTotal - item.subTotal * (item.discountPercent / 100);
          item.discountNominal = item.subTotal * (item.discountPercent / 100);
        } else {
          item.total = item.subTotal - item.discountNominal;
          item.discountPercent = (item.discountNominal / item.subTotal) * 100;
        }
        if (!override) {
          this.findAndPushItem(item, 'discount_item');
        }
      }
    },

    onInputXtraDiscount() {
      if (this.shouldCalc) {
        const totalPrice = this.itemBilling.reduce(
          (next, prev) => next + prev.billing.reduce((a, b) => a + b.total, 0),
          0,
        );
        if (this.extraDiscountType === 'percent') {
          this.discNominal = totalPrice * (this.discPercent / 100);
        } else {
          this.discPercent = (this.discNominal / totalPrice) * 100;
        }
        this.findAndPushItem({ id: 'discount_all' }, 'discount_all');
      }
    },

    onInputQty(event, index, itemIndex) {
      const item = this.itemBilling[index].billing[itemIndex];
      item.subTotal = item.quantity * item.price;
      const discount =
        item.discountType === 'percent'
          ? item.discountPercent
          : item.discountNominal;
      this.onInputDiscount(discount, index, itemIndex, true);
      this.findAndPushItem(item, 'quantity_item');
    },

    findAndPushItem(item, updateType) {
      let payload = null;

      if (updateType === 'discount_item') {
        payload = {
          update_type: updateType,
          id: item.id,
          unit_name: item.unit_name,
          type: item.type,
          discount_nominal: Math.round(item.discountNominal * 100) / 100 || 0,
          discount_percent: Math.round(item.discountPercent * 100) / 100 || 0,
          discount_type: item.discountType,
        };
      } else if (updateType === 'quantity_item') {
        payload = {
          update_type: updateType,
          id: item.id,
          unit_name: item.unit_name,
          type: item.type,
          quantity: item.quantity,
        };
      } else {
        payload = {
          update_type: updateType,
          id: item.id,
          discount_nominal: Math.round(this.discNominal * 100) / 100 || 0,
          discount_percent: Math.round(this.discPercent * 100) / 100 || 0,
          discount_type: this.extraDiscountType,
          discount_reason: this.discountReason,
        };
      }
      const findItemId = this.updatePayload.find(
        f => f.id === item.id && f.update_type === updateType,
      );
      if (!findItemId) {
        this.updatePayload.push(payload);
      } else {
        this.updatePayload = this.updatePayload.map(item => {
          if (findItemId.id === item.id) {
            return payload;
          }
          return item;
        });
      }
    },

    formatToNumber(formattedText) {
      let temp = formattedText;
      if (temp) {
        temp = temp.toString();
        return parseFloat(temp.replace(/\./g, ''), 10);
      }
      return formattedText;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-label {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
}

.card-label {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: start;
  width: 200px;
}

.text-light-grey {
  color: #9e9e9e;
}

.text-dark-grey {
  color: #404040;
}

.text-blue {
  color: #1565c0;
}
.v-dialog > .v-card > .v-card__title {
  padding: 24px 24px 16px 24px !important;
}

.container-width {
  max-width: 95vw !important;
}

.v-small-dialog__content {
  text-align: left !important;
}

.box-data {
  &__grey {
    border: 1px solid #9ca2a5;
    border-radius: 4px;
    background-color: #f5f5f5;
  }
  &__blue {
    border: 0.5px solid #bdbdbd;
    border-radius: 4px;
    background-color: #f0f9ff;
  }
}

.box-green {
  border-radius: 4px;
  background-color: #e7f8ec;
  color: #268843;
}

.price-box {
  min-width: 300px;
  display: flex;
  justify-content: space-between;
  background-color: #fafafa;
  border-radius: 4px;
  padding: 8px;
  font-size: 0.9rem;
  color: #616161;

  .price-text {
    font-weight: 500;
    color: #1565c0;
  }
}

.border-right {
  border-right: 3px solid #ededed;
}
.button-payment {
  &.active {
    background-color: #3498db !important;
    color: white;
  }
}

.total-row {
  background-color: #f4f5f5;
}
.scrollbar {
  &::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
    background-color: #d4d4d4;
  }
  &::-webkit-scrollbar-thumb {
    width: 5px;
    border-radius: 5px;
    background-color: rgb(123, 121, 121);
  }
}

.v-dialog > .v-card > .v-card__actions {
  position: absolute;
  width: 100%;
  bottom: 1px;
}

.swal2-icon.swal2-question {
  border-color: #f2c94c;
  opacity: 0.2;
  color: #f2c94c;
}
.overpayment-info {
  background-color: #f0f8fe;
  width: fit-content;
}

.table-header-text {
  color: #616161;
}

::v-deep .v-card__title.d-flex.justify-center {
  padding: 10px !important;
}

::v-deep {
  .v-data-table .v-data-table-header {
    background-color: #f4f5f5;

    span {
      color: #9e9e9e;
    }
  }

  .total-footer {
    background-color: #f4f5f5 !important;
    color: #404040 !important;
  }
}

::v-deep {
  .v-input.v-input--is-disabled .v-input__control .v-input__slot::before {
    border: none;
  }
}

.dropdown {
  min-height: 3rem;
  text-align: left;
}
.dropdown:hover {
  background-color: #e6f6fe;
  cursor: pointer;
}
.dropdown-item {
  color: #404040;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}
.input-end :deep(input) {
  text-align: end;
}
</style>
